import { render } from "./CustomerProfileUpdate.vue?vue&type=template&id=7ed8d23f&scoped=true"
import script from "./CustomerProfileUpdate.vue?vue&type=script&lang=js"
export * from "./CustomerProfileUpdate.vue?vue&type=script&lang=js"

import "./CustomerProfileUpdate.vue?vue&type=style&index=0&id=7ed8d23f&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed8d23f"]])

export default __exports__